<!--<div *ngIf="isReady && breadcrumbBar && breadcrumbBar.isVisible">-->
<!--  <particle-breadcrumb-bar [breadcrumbBar]="breadcrumbBar"></particle-breadcrumb-bar>-->
<!--</div>-->
<div *ngIf="isReady && toolbar && toolbar.isVisible">
  <particle-tool-bar [magicLinkModel]="magicLinkModel" [toolbar]="toolbar"
                     (afterExecuteCommand)="afterExecuteCommand($event)"></particle-tool-bar>
</div>
<div *ngIf="isReady && !isResponseView && !isManageFields">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">

    <div class="flex flex-row justify-start items-center">
      <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
        <label class="component-label"> Actions</label>
        <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
          <div class="button-container flex flex-row justify-start items-center">
            <button mat-button class="orbitax-flat-button" (click)="addTopic()" particleAnalytics
                    analyticsCategory="entity-transactions-content" analyticsAction="add-section">Add Topic
            </button>
            <div class="toolbar-separator"></div>
          </div>
        </div>
      </div>

      <div class="m-t-25 flex flex-row justify-start items-center">
        <div class="divider"></div>
        <mat-slide-toggle (change)="toggle()" class="data-survey" [disabled]="flowChartMode!=='design'">Show Excluded
          Items
        </mat-slide-toggle>
        <div class="divider"></div>
        <mat-slide-toggle (change)="toggleView()" class="data-survey">Preview</mat-slide-toggle>
      </div>
    </div>

    <div class="flex flex-row justify-start items-center">
      <button mat-button class="dash-button m-r-20" (click)="editDetailsAndInstructions()"
              particleAnalytics
              analyticsCategory="Details-Instructions"
              analyticsAction="Details-Instructions"><i class="fal fa-info-circle"></i> Details & Instructions
      </button>

      <button mat-button class="start-data-survey" (click)="startExecution()"
              particleAnalytics
              analyticsCategory="data-survey"
              analyticsAction="send-survey"><i class="far fa-share"></i> Create Data Survey
      </button>
    </div>

  </div>
</div>
<div *ngIf="isReady && flowcharts && flowChartMode =='design'" class="flex flex-row full-grow-no-shrink-no-basis">
  <mat-tab-group [ngClass]="isManageFields? 'hideTabHeader custom-mat-tab': 'custom-mat-tab'"
                 (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab *ngFor="let flowchart of flowcharts; let i = index" label="{{flowchart.header}}">
      <ng-template mat-tab-label>
        <div class="custom-tab-header flex flex-row justify-start items-center" title="{{flowchart.toolHeader}}">
          <div class="flex flex-col justify-start items-center">
            <div class="tool-name">{{flowchart.productHeader}}</div>
            <div class="header" title="{{flowchart.toolHeader}}">{{flowchart.toolHeader}}</div>
          </div>
          <button class="arrow" [matMenuTriggerFor]="topicMenu">
            <i class="fa fa-chevron-down"></i>
          </button>
          <mat-menu #topicMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
            <button *ngIf="flowchart.isCustom" mat-menu-item class=""
                    (click)="renameTopic(flowchart);$event.stopPropagation();">
              <span>Rename Topic</span>
            </button>
            <button mat-menu-item class="" *ngIf="flowcharts.length>1"
                    (click)="deleteTopic(flowchart);$event.stopPropagation();">
              <span>Remove Topic</span>
            </button>
            <!--            <button mat-menu-item class=""  (click)="moveTopic('left')">-->
            <!--              <span>Move Left</span>-->
            <!--            </button>-->
            <!--            <button mat-menu-item class=""  (click)="moveTopic('right')">-->
            <!--              <span>Move Right</span>-->
            <!--            </button>-->
          </mat-menu>
        </div>
      </ng-template>
      <div *ngIf="i === selectedTabIndex" class="main-scrolling-area flex flex-row justify-start items-start"
           [ngClass]="isManageFields?'manage-filed-background':'data-survey-background'">
        <div class="fixed-width-area flex flex-col">
          <div class="root-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis">

            <mat-accordion class="full-grow-no-shrink-no-basis">

              <!-- #enddocregion basic-panel -->
              <mat-expansion-panel *ngFor="let section of sections; let i = index;"
                                   (opened)="section.panelOpenState = true"
                                   (closed)="section.panelOpenState = false"
                                   [expanded]="defaultExpansionPanelIndex==i ? true : section.panelOpenState">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{section?.title}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <particle-flow-chart-group-view *ngIf="sourceType && section.type=='Group' && section.panelOpenState"
                                                [section]="section" [sourceType]="sourceType"
                                                [flowChartDataService]="flowChartDataService"
                                                [totalSections]="sections.length"
                                                [flowchart]="flowchart"
                >

                </particle-flow-chart-group-view>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </mat-tab>

    <!--    <mat-tab disabled *ngIf="this.isManageFields===false">-->
    <!--      <ng-template mat-tab-label>-->
    <!--        <button (click)="addTopic()" class="add-topic-button">-->
    <!--          <i class="far fa-plus-circle"></i> Add Topic-->
    <!--        </button>-->
    <!--      </ng-template>-->
    <!--    </mat-tab>-->

  </mat-tab-group>
</div>
<div *ngIf="isReady && survey && surveyId == survey.id && flowChartMode=='response'"
     class="flex flex-row full-grow-no-shrink-no-basis">
  <mat-tab-group *ngIf="!hideFlowchartTabs" class="custom-mat-tab"
                 (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab *ngFor="let flowchart of flowcharts; let i = index" label="{{flowchart.header}}">
      <ng-template mat-tab-label>
        <div class="custom-tab-header flex flex-row justify-start items-center">
          <div class="flex flex-col justify-start items-center">
            <div class="tool-name">{{flowchart.toolHeader}}</div>
            <div class="header">{{flowchart.productHeader}}</div>
          </div>
        </div>
      </ng-template>
      <div *ngIf="i === selectedTabIndex" class="main-scrolling-area flex flex-row justify-start items-start">
        <div class="fixed-width-area flex flex-col">
          <div
            class="root-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis full-grow-no-shrink-no-basis">
            <mat-accordion class="full-grow-no-shrink-no-basis">

              <!-- #enddocregion basic-panel -->
              <mat-expansion-panel *ngFor="let section of sections; let i = index;"
                                   (opened)="section.panelOpenState = true"
                                   (closed)="section.panelOpenState = false"
                                   [expanded]="defaultExpansionPanelIndex==i ? true : section.panelOpenState">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{section?.title}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <particle-flow-chart-response-group-view
                  *ngIf="sourceType && section.type=='Group' && section.questions.length>0 && section.panelOpenState"
                  [section]="section"
                  [surveyId]="surveyId" [sourceType]="sourceType" [rowItem]="rowItem"
                  [fieldDefinitions]="fieldDefinitions"></particle-flow-chart-response-group-view>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div *ngIf="hideFlowchartTabs" class="main-scrolling-area flex flex-row justify-start items-start">
    <div class="fixed-width-area flex flex-col">
      <div class="root-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
        <mat-accordion class="full-grow-no-shrink-no-basis">

          <!-- #enddocregion basic-panel -->
          <mat-expansion-panel *ngFor="let section of sections; let i = index;" (opened)="section.panelOpenState = true"
                               (closed)="section.panelOpenState = false"
                               [expanded]="defaultExpansionPanelIndex==i ? true : section.panelOpenState">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{section?.title}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <particle-flow-chart-response-group-view
              *ngIf="sourceType && section.type=='Group' && section.questions.length>0 && section.panelOpenState"
              [section]="section"
              [surveyId]="surveyId" [sourceType]="sourceType" [rowItem]="rowItem"
              [fieldDefinitions]="fieldDefinitions"></particle-flow-chart-response-group-view>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
